import { render, staticRenderFns } from "./confirm_sending_email.vue?vue&type=template&id=3095b96a&scoped=true&"
import script from "./confirm_sending_email.vue?vue&type=script&lang=js&"
export * from "./confirm_sending_email.vue?vue&type=script&lang=js&"
import style0 from "./confirm_sending_email.vue?vue&type=style&index=0&id=3095b96a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3095b96a",
  null
  
)

export default component.exports